module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img4.ea2b83463dae47f227491d2954747226.jpg";